/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Ivory_Eel_RunInputs */

const en_keen_ivory_eel_run = /** @type {(inputs: Keen_Ivory_Eel_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firstname`)
};

const de_keen_ivory_eel_run = /** @type {(inputs: Keen_Ivory_Eel_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "Firstname" |
*
* @param {Keen_Ivory_Eel_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_ivory_eel_run = /** @type {((inputs?: Keen_Ivory_Eel_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Ivory_Eel_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_ivory_eel_run(inputs)
	return de_keen_ivory_eel_run(inputs)
});